import React, { useState, useEffect } from 'react';
import { LanguageCode, LanguageOptionType } from './weglot-switcher.models';
import { FlagIcon } from '../../../design/icons/flag.icon';
import { ArrowIcon } from '@keplerco/core';
import CircleCheckIcon from '../../../design/icons/circle-check.icon';
import styles from './weglot-switcher.module.css';
import classNames from 'classnames';

const languageOptions: LanguageOptionType[] = [
  { code: 'zh', flag: <FlagIcon isoCode="CN" />, name: 'Chinese (Simplified)', abbreviation: 'ZHO' },
  { code: 'en', flag: <FlagIcon isoCode="GB" />, name: 'English', abbreviation: 'ENG' },
  { code: 'es', flag: <FlagIcon isoCode="ES" />, name: 'Spanish', abbreviation: 'SPA' },
  { code: 'fr', flag: <FlagIcon isoCode="FR" />, name: 'French', abbreviation: 'FRA' },
  { code: 'de', flag: <FlagIcon isoCode="DE" />, name: 'German', abbreviation: 'GER' },
  { code: 'ja', flag: <FlagIcon isoCode="JP" />, name: 'Japanese', abbreviation: 'JPN' },
  { code: 'ko', flag: <FlagIcon isoCode="KR" />, name: 'Korean', abbreviation: 'KOR' },
  { code: 'pt', flag: <FlagIcon isoCode="PT" />, name: 'Portuguese', abbreviation: 'POR' },
  { code: 'vi', flag: <FlagIcon isoCode="VN" />, name: 'Vietnamese', abbreviation: 'VIE' },
];

// TODO: refactor to use 'DropdownList' and be more consistent with other Dropdowns' UX
export default function WeglotLanguageSwitcher() {
  const [currentLanguageCode, setCurrentLanguageCode] = useState<keyof LanguageCode>('en');
  const [showList, setShowList] = useState(false);

  useEffect(() => {
    if ((window as any).Weglot) {
      setCurrentLanguageCode((window as any).Weglot.getCurrentLang());
    }
  }, []);

  function onClickOption(lang: keyof LanguageCode) {
    if ((window as any).Weglot) {
      (window as any).Weglot.switchTo(lang);
      setCurrentLanguageCode(lang);
      setShowList(false);
    }
  }

  return (
    <div className={styles.container}>
      <button className={styles.button} onClick={() => setShowList(!showList)}>
        {languageOptions.find(option => option.code === currentLanguageCode)?.flag}
        {languageOptions.find(option => option.code === currentLanguageCode)?.abbreviation}
        <ArrowIcon tone="primary" size={15} rotation={showList ? 3 : 1} />
      </button>

      {showList && (
        <div className={styles.list}>
          <h5>Language</h5>

          {languageOptions.map(({ code, flag, name }: LanguageOptionType) => (
            <div key={code} className={classNames('body', styles.option)} onClick={() => onClickOption(code)}>
              {flag} {name}
              {currentLanguageCode === code && <CircleCheckIcon />}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
